import { message } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import Compress from 'react-image-file-resizer';
import { useHistory } from 'react-router-dom';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';

const InspeccionContext = React.createContext({});

export function InspeccionProvider(props) {
  const [inspeccion, setInspeccion] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingImages, setLoadingImages] = useState(false);
  const [hasImagenes, setHasImagenes] = useState(false);
  const [images, setImages] = useState([]);
  const imagenes = [];
  const history = useHistory();

  useEffect(() => {}, []);

  const getInspeccion = async (token, fullPath) => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `/inspeccion/${token}?fullPath=${fullPath}`
      );
      getImages(response.data.data);
      setLoading(false);
      setInspeccion(response.data.data);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        message.error(error.response.data.message);
        history.push(
          `/regenerar-token?flujo=inspeccion&tokenExpirado=${token}`
        );
      } else {
        errorHandler(error, 'Error al obtener los datos');
      }
      return {};
    }
  };

  const finalizar = async (values) => {
    try {
      await instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
        comentarios: values.comentario
      });
      return true;
    } catch (error) {
      errorHandler(error);
    }
    return false;
  };

  const updateInspeccion = (status, comentarios) => {
    return instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
      estado: status,
      comentarios
    });
  };

  const getImages = async (inspeccionParam) => {
    try {
      setLoadingImages(true);
      const responseArchivos = await instanceRef.instance.get(`/archivos/`, {
        params: {
          filter: {
            token: inspeccionParam.token,
            type: 'i',
            url: true,
            marked: false,
            base64: false,
            imgcompress: true
          }
        }
      });
      setLoadingImages(false);
      setImages(responseArchivos.data.data);
      return responseArchivos.data.data;
    } catch (error) {
      // error
    }
    setLoadingImages(false);
    return {};
  };

  const getImagePaso = async (inspeccionParam, nroPaso) => {
    try {
      setLoadingImages(true);
      const responseArchivo = await instanceRef.instance.get(`/archivos/`, {
        params: {
          filter: {
            token: inspeccionParam.token,
            type: 'i',
            url: true,
            marked: false,
            base64: false,
            imgcompress: true,
            pasoNro: Number(nroPaso)
          }
        }
      });
      setLoadingImages(false);
      if (responseArchivo.data?.data) {
        setImages([...images, responseArchivo.data.data[0]]);
      }
      return responseArchivo.data.data;
    } catch (error) {
      // error
    }
    setLoadingImages(false);
    return {};
  };

  function setHasImagenesFunction(hasImagenesParam) {
    setHasImagenes(hasImagenesParam);
  }

  function uploadView(file, pasoNro, inspeccionEdit, parte) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append(
        'empresa',
        inspeccionEdit.solicitud.cotizacion.aseguradoraEmpresa.empresa.nombre
      );
      formData.append(
        'aseguradora',
        inspeccionEdit.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
          .descripcion
      );
      formData.append(
        'nombres',
        `${inspeccionEdit?.solicitud?.cotizacion?.persona.nombres} ${inspeccion?.solicitud?.cotizacion?.persona.apellidos}`
      );
      formData.append(
        'chapa',
        inspeccionEdit?.solicitud?.cotizacion?.vehiculo.chapa
      );
      formData.append('token', inspeccionEdit.token);
      formData.append('paso_nro', pasoNro);
      formData.append('type', 'i');
      formData.append('imgcompress', true);
      if (parte) {
        formData.append('parte', parte);
      }
      const response = instanceRef.instance.post(
        `archivos/imgcompress`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      return response;
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      return false;
    }
  }

  const uploadFile = async (file, pasoNro, inspeccionEdit, parte) => {
    setHasImagenesFunction(true);
    if (
      inspeccion && // 👈 null and undefined check
      Object.keys(inspeccion).length === 0 &&
      inspeccion.constructor === Object
    ) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'empresa',
          inspeccionEdit.solicitud.cotizacion.aseguradoraEmpresa.empresa.nombre
        );
        formData.append(
          'aseguradora',
          inspeccionEdit.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
            .descripcion
        );
        formData.append(
          'nombres',
          `${inspeccionEdit?.solicitud?.cotizacion?.persona.nombres} ${inspeccion?.solicitud?.cotizacion?.persona.apellidos}`
        );
        formData.append(
          'chapa',
          inspeccionEdit?.solicitud?.cotizacion?.vehiculo.chapa
        );
        formData.append('token', inspeccionEdit.token);
        formData.append('paso_nro', pasoNro);
        formData.append('type', 'i');
        formData.append('imgcompress', false);
        if (parte) {
          formData.append('parte', parte);
        }

        const response = await instanceRef.instance.post(
          `archivos/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        await Compress.imageFileResizer(
          file, // the file from input
          480, // width
          480, // height
          'JPEG', // compress format WEBP, JPEG, PNG
          70, // quality
          0, // rotation
          (uri) => {
            uploadView(uri, pasoNro, inspeccionEdit, parte);
          },
          'blob' // blob or base64 default base64
        );
        await updateInspeccion('INICIADA');
        await getImagePaso(inspeccionEdit, pasoNro);
        return response;
      } catch (error) {
        errorHandler(error, 'Error al subir el archivo');
        return false;
      }
    } else {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'empresa',
          inspeccion.solicitud.cotizacion.aseguradoraEmpresa.empresa.nombre
        );
        formData.append(
          'aseguradora',
          inspeccion.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
            .descripcion
        );
        formData.append(
          'nombres',
          `${inspeccion?.solicitud?.cotizacion?.persona.nombres} ${inspeccion?.solicitud?.cotizacion?.persona.apellidos}`
        );
        formData.append(
          'chapa',
          inspeccion?.solicitud?.cotizacion?.vehiculo.chapa
        );
        formData.append('token', inspeccion.token);
        formData.append('paso_nro', pasoNro);
        formData.append('type', 'i');
        formData.append('imgcompress', false);
        if (parte) {
          formData.append('parte', parte);
        }

        const response = await instanceRef.instance.post(
          `archivos/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        await Compress.imageFileResizer(
          file, // the file from input
          480, // width
          480, // height
          'JPEG', // compress format WEBP, JPEG, PNG
          70, // quality
          0, // rotation
          (uri) => {
            uploadView(uri, pasoNro, inspeccionEdit, parte);
          },
          'blob' // blob or base64 default base64
        );
        await updateInspeccion('INICIADA');
        // await getImages(inspeccion);
        await getImagePaso(inspeccionEdit, pasoNro);

        return response;
      } catch (error) {
        errorHandler(error, 'Error al subir el archivo');
        return false;
      }
    }
  };

  const uploadMarkedFile = async (
    solicitud2,
    inspeccionToken,
    file,
    nroPaso,
    fileName
  ) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fileName', fileName);
      formData.append(
        'empresa',
        solicitud2.cotizacion.aseguradoraEmpresa.empresa.nombre
      );
      formData.append(
        'aseguradora',
        solicitud2.cotizacion.aseguradoraEmpresa.aseguradora.descripcion
      );
      formData.append(
        'nombres',
        `${solicitud2?.cotizacion?.persona.nombres} ${solicitud2?.cotizacion?.persona.apellidos}`
      );
      formData.append('chapa', solicitud2?.cotizacion?.vehiculo.chapa);
      formData.append('token', inspeccionToken);
      formData.append('paso_nro', nroPaso);
      await instanceRef.instance.post(`archivos/marked`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
    }
  };

  const archivoAddParte = async (inspeccionId, pasoNro, parte) => {
    try {
      const params = {
        inspeccionId,
        pasoNro,
        parte
      };

      await instanceRef.instance.post(`archivos/update/`, { params });
      return true;
    } catch (error) {
      errorHandler(error);
    }
    return false;
  };

  const archivoAddComentario = async (
    inspeccionId,
    pasoNro,
    comentario,
    ampliacionId
  ) => {
    try {
      const params = {
        inspeccionId,
        pasoNro,
        comentario,
        ampliacionId
      };

      await instanceRef.instance.post(`archivos/update/`, { params });
      return true;
    } catch (error) {
      errorHandler(error);
    }
    return false;
  };

  const value = useMemo(() => {
    return {
      loading,
      loadingImages,
      inspeccion,
      getInspeccion,
      getImages,
      setLoading,
      images,
      imagenes,
      finalizar,
      hasImagenes,
      setHasImagenesFunction,
      setHasImagenes,
      uploadFile,
      updateInspeccion,
      uploadMarkedFile,
      archivoAddComentario,
      archivoAddParte
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspeccion, images, hasImagenes]);
  return <InspeccionContext.Provider value={value} {...props} />;
}

export function useInspeccionContext() {
  const context = React.useContext(InspeccionContext);
  if (!context) {
    throw new Error('useInspeccionContext debe estar dentro del Proveedor ');
  }
  return context;
}
